// import { MarkerClusterer } from "@googlemaps/markerclusterer";

class FrontpageGoogleMap {
    constructor() {
        let $ = jQuery;
        let self = this;

        if (document.getElementById("mm__frontpage-map")) {
            // self.initMap(document.getElementById("mm__frontpage-map"));
            self.initMapOSM(document.getElementById("mm__frontpage-map"));
        }

        let map;
        let markers;
    }

    showStoreInfo(store) {
		var $storeInfo = $('#store-info');
		var $header = $('.header', $storeInfo);
		var $contact = $('.contact', $storeInfo);
		var $more = $('.more', $storeInfo);

		$header.empty();
		$contact.empty();
		$more.empty();

		$header.html('<h2 class="store-header">' + store.name + '</h2><span class="address">' + store.address + '</span>');

		storeFinderGetStore(store.storeId).done(function (response) {
			if (true === response.success) {
				$contact.html(response.data);
			}
		});
	}

    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    initMap($el) {
        let $ = jQuery;

        // Find marker elements within map.
        let $markers = JSON.parse($el.dataset.markers);

        // Removes points of intrest from the map
        let removeDefaultLabels = [
            {
                featureType: "poi",
                elementType: "labels",
                stylers: [
                    { visibility: "off" }
                ]
            }
        ];

        // Create generic map.
        let mapArgs = {
            zoom: 4,
            center: { lat: 64.3910011, lng: 16.7393019 },
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            zoomControl: false,
            styles: removeDefaultLabels,
        };

        const map = new google.maps.Map($el, mapArgs);
        this.map = map;

        const markers = $markers.map((m) => {
            let position = new google.maps.LatLng(m.lat, m.lng);
            let icon = m.icon

            const marker = new google.maps.Marker({
                position: position,
                icon: icon,
                animation: google.maps.Animation.DROP,
                map: this.map,
            })

            marker.set('storeId', m.postID);
            marker.set('town', m.town);
            marker.set('name', m.name);    
            marker.set('url', m.url);    

            return marker;
        });

        this.markers = markers;

        const renderer = {
            render({ count, position }) {
                return new google.maps.Marker({
                    label: { 
                        text: String(count), color: "white", fontSize: "11px",
                    },
                    position,
                    icon: {
                        url: `${wpurl.site}/resources/dist/images/marker-cluster.svg`,
                        scaledSize: new google.maps.Size(45, 55),
                        labelOrigin: new google.maps.Point(22.5, 22.5)
                    },
                    // adjust zIndex to be above other markers
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                })
            }
        };

        const clusterer = new MarkerClusterer({
            map,
            markers,
            renderer
        });
    }


    initMapOSM($el){
        let $ = jQuery;

        if($('#mm__frontpage-map').length == 0 )
            return;

        /* Responsive map */
            
        // var map = L.map('mm__frontpage-map').setView([62.3910011, 16.7393019], 6);
       
        let markers = JSON.parse($el.dataset.markers);
        
        console.log("markers frontpage map");
        console.log(markers);

        var map = L.map($el).setView([62.3910011, 16.7393019], 5);

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 15,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(map);

        L.Marker.prototype.options.icon = L.icon({
            iconUrl: "/wp-content/themes/nordsjo-theme/resources/dist/images/map-pin.png",
        });

        /* Clusters and marker HTML */
        if(markers.length > 0) {
            var cluster = L.markerClusterGroup({
                spiderfyOnMaxZoom: false,
                showCoverageOnHover: false,
                zoomToBoundsOnClick: true
            });
            for (var i = 0; i < markers.length; i++) {
                if(markers[i].lat && markers[i].lng){
                    
                cluster.addLayer(L.marker([
                    markers[i].lat, markers[i].lng
                ]));
                map.addLayer(cluster);

            }
            }
        }
        return map;
    }

}

export default FrontpageGoogleMap;
